// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require('angular')
require('angular-sanitize')
require('lodash')
require('jquery-reveal')

function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('../components/checker_app/', true, /\.js$/));